<div class="show-more"
     (click)="onClickPage()"
     [class.hidden]="!hasNext"
>
  Показать больше
</div>
